'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _reactRedux = require('react-redux');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _addressLookup = require('../../selectors/address-lookup');
var _withFormId = require('../../hocs/with-form-id');
var _withFormId2 = _interopRequireDefault(_withFormId);
var _readOnly = require('../read-only');
var _readOnly2 = _interopRequireDefault(_readOnly);
var _formField = require('../form-field');
var _formField2 = _interopRequireDefault(_formField);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Group = (0, _glamorous2.default)('div')(function (_ref) {
  var theme = _ref.theme;
  return {
    paddingBottom: theme.space_xs
  };
});
var Details = function (_Component) {
  _inherits(Details, _Component);
  function Details() {
    _classCallCheck(this, Details);
    return _possibleConstructorReturn(this, (Details.__proto__ || Object.getPrototypeOf(Details)).apply(this, arguments));
  }
  _createClass(Details, [{
    key: 'render',
    // The full address from the api in an input panel
    value: function render() {
      return _react2.default.createElement(_formField2.default, {
        name: this.props.name,
        label: this.props.label ? this.props.label : "Address"
      }, _react2.default.createElement(_readOnly2.default, null, _react2.default.createElement(Group, null, this.props.address.line1, _react2.default.createElement('br', null), this.props.address.line2.length ? _react2.default.createElement(_react.Fragment, null, this.props.address.line2, _react2.default.createElement('br', null)) : null, this.props.address.townCity, _react2.default.createElement('br', null), this.props.address.county, _react2.default.createElement('br', null), this.props.address.postcode), _react2.default.createElement('a', {
        onClick: this.props.clearAddress
      }, 'Change your address')));
    }
  }]);
  return Details;
}(_react.Component);
Details.propTypes = {
  // props
  name: _propTypes.string.isRequired,
  clearAddress: _propTypes.func.isRequired,
  label: _propTypes.string,
  // stp
  address: (0, _propTypes.shape)({
    line1: _propTypes.string.isRequired,
    line2: _propTypes.string,
    townCity: _propTypes.string.isRequired,
    county: _propTypes.string.isRequired,
    postcode: _propTypes.string.isRequired
  }).isRequired
};
exports.default = (0, _withFormId2.default)((0, _reactRedux.connect)(function (state, ownProps) {
  return {
    address: (0, _addressLookup.addressFields)(state, ownProps.formId, ownProps.name)
  };
})(Details));